import { User } from './types';
import { axiosClient } from '../axiosClient';

export const getUsers = () => {
  return axiosClient.get<User[]>('/users');
};
